import { createContext, useContext, useState } from 'react'

const translations = {
  en: {
    // Nav
    dashboard:     'Dashboard',
    myTickets:     'My tickets',
    submitTicket:  'Submit Ticket',
    submittedTickets: 'Submitted Tickets',
    newTicket:     'New ticket',
    profile:       'Profile',
    notifications: 'Notifications',
    signOut:       'Sign out',
    account:       'Account',

    // Site select
    chooseSite:    'Choose your site / portal',
    siteSubtitle:  'Select the site you belong to — each portal is customised for your organisation',
    noSite:        "Don't see your site?",
    contactAdmin:  'Contact your administrator',

    // Auth
    signIn:        'Sign in',
    sharedLogin:   'One account works across all sites',
    emailLabel:    'Email address',
    passwordLabel: 'Password',
    rememberMe:    'Remember me',
    forgotPass:    'Forgot password?',
    sharedNote:    'Shared login · Your account is linked to all sites you have access to',
    changeSite:    '← Change site',
    portalLabel:   'User Support Portal',

    // Dashboard
    welcomeBack:   'Welcome back',
    activityOverview: "Here's an overview of your support activity",
    totalTickets:  'Total tickets',
    inProgress:    'In progress',
    resolved:      'Resolved',
    recentTickets: 'Recent tickets',
    viewAll:       'View all tickets',

    // Tickets
    trackTickets:  'Submitted Tickets',
    trackSubtitle: 'View submitted tickets, status updates, and latest replies',
    searchTickets: 'Search tickets…',
    allStatuses:   'All statuses',
    statusNew:     'New',
    statusOpen:    'Open',
    statusInProgress: 'In progress',
    statusResolved: 'Resolved',
    tabAll:        'All',
    tabOpen:       'Open',
    tabInProgress: 'In progress',
    tabResolved:   'Resolved',

    // Submit
    submitTitle:   'Submit a ticket',
    submitSubtitle: "Describe your issue and we'll get back to you shortly",
    category:      'Category',
    subCategory:   'Sub-category',
    subject:       'Subject',
    priority:      'Priority',
    description:   'Description',
    low:           'Low',
    medium:        'Medium',
    high:          'High',
    critical:      'Critical',
    attachFiles:   'Drag & drop files or browse',
    cancel:        'Cancel',
    submit:        'Submit ticket',

    // Ticket detail
    backToTickets: 'Submitted Tickets',
    assignedTo:    'Assigned to',
    expectedRes:   'Expected resolution',
    resProgress:   'Resolution progress',
    activity:      'Activity & updates',
    addReply:      'Add a reply',
    replyPlaceholder: 'Type your message here…',
    sendReply:     'Send reply',
    openedAgo:     'Opened',

    // Profile
    myProfile:     'Profile',
    profileSub:    'Manage your account and preferences',
    userRole:      'User / Member',
    accessSites:   'Accessible sites',
    personalInfo:  'Personal information',
    firstName:     'First name',
    lastName:      'Last name',
    email:         'Email',
    phone:         'Phone',
    department:    'Department',
    primarySite:   'Primary site',
    discard:       'Discard',
    saveChanges:   'Save changes',
    preferences:   'Preferences',
    language:      'Language / Bahasa',
    emailNotif:    'Email notifications',
    allUpdates:    'All updates',
    statusOnly:    'Status changes only',
    none:          'None',
    notificationsSub: 'View ticket updates and important alerts',
    markAllRead:   'Mark all as read',
    notifStatusTitle: 'Ticket status updated',
    notifReplyTitle: 'New staff reply',
    notifResolvedTitle: 'Ticket resolved',
    ticketSummary: 'Ticket summary',
    attach:        'Attach',

    // General
    itSupport:     'IT Support',
    facilities:    'Facilities',
    hr:            'HR',
    network:       'Network',
    hardware:      'Hardware',
    software:      'Software',
    optional:      'Optional' 
  },

  bm: {
    // Nav
    dashboard:     'Papan Pemuka',
    myTickets:     'Tiket Saya',
    submitTicket:  'Hantar Tiket',
    submittedTickets: 'Tiket Dihantar',
    newTicket:     'Tiket Baru',
    profile:       'Profil',
    notifications: 'Pemberitahuan',
    signOut:       'Log Keluar',
    account:       'Akaun',

    // Site select
    chooseSite:    'Pilih tapak / portal anda',
    siteSubtitle:  'Pilih tapak yang anda daftarkan — setiap portal disesuaikan untuk organisasi anda',
    noSite:        'Tapak anda tidak tersenarai?',
    contactAdmin:  'Hubungi pentadbir anda',

    // Auth
    signIn:        'Log masuk',
    sharedLogin:   'Satu akaun untuk semua tapak',
    emailLabel:    'Alamat e-mel',
    passwordLabel: 'Kata laluan',
    rememberMe:    'Ingat saya',
    forgotPass:    'Lupa kata laluan?',
    sharedNote:    'Log masuk dikongsi · Akaun anda dikaitkan dengan semua tapak yang anda ada akses',
    changeSite:    '← Tukar tapak',
    portalLabel:   'Portal Sokongan Pengguna',

    // Dashboard
    welcomeBack:   'Selamat kembali',
    activityOverview: 'Berikut adalah ringkasan aktiviti sokongan anda',
    totalTickets:  'Jumlah tiket',
    inProgress:    'Dalam proses',
    resolved:      'Selesai',
    recentTickets: 'Tiket terkini',
    viewAll:       'Lihat semua tiket',

    // Tickets
    trackTickets:  'Tiket Dihantar',
    trackSubtitle: 'Lihat tiket yang dihantar, status dan balasan terkini',
    searchTickets: 'Cari tiket…',
    allStatuses:   'Semua status',
    statusNew:     'Baru',
    statusOpen:    'Terbuka',
    statusInProgress: 'Dalam proses',
    statusResolved: 'Selesai',
    tabAll:        'Semua',
    tabOpen:       'Terbuka',
    tabInProgress: 'Dalam proses',
    tabResolved:   'Selesai',

    // Submit
    submitTitle:   'Hantar tiket',
    submitSubtitle: 'Huraikan isu anda dan kami akan menghubungi anda segera',
    category:      'Kategori',
    subCategory:   'Sub-kategori',
    subject:       'Perkara',
    priority:      'Keutamaan',
    description:   'Penerangan',
    low:           'Rendah',
    medium:        'Sederhana',
    high:          'Tinggi',
    critical:      'Kritikal',
    attachFiles:   'Seret & lepaskan fail atau semak imbas',
    cancel:        'Batal',
    submit:        'Hantar tiket',

    // Ticket detail
    backToTickets: 'Tiket Dihantar',
    assignedTo:    'Ditugaskan kepada',
    expectedRes:   'Jangkaan penyelesaian',
    resProgress:   'Kemajuan penyelesaian',
    activity:      'Aktiviti & kemaskini',
    addReply:      'Tambah balasan',
    replyPlaceholder: 'Taip mesej anda di sini…',
    sendReply:     'Hantar balasan',
    openedAgo:     'Dibuka',

    // Profile
    myProfile:     'Profil saya',
    profileSub:    'Urus akaun dan pilihan anda',
    userRole:      'Pengguna / Ahli',
    accessSites:   'Tapak yang boleh diakses',
    personalInfo:  'Maklumat peribadi',
    firstName:     'Nama pertama',
    lastName:      'Nama akhir',
    email:         'E-mel',
    phone:         'Telefon',
    department:    'Jabatan',
    primarySite:   'Tapak utama',
    discard:       'Buang',
    saveChanges:   'Simpan perubahan',
    preferences:   'Pilihan',
    language:      'Bahasa / Language',
    emailNotif:    'Pemberitahuan e-mel',
    allUpdates:    'Semua kemaskini',
    statusOnly:    'Perubahan status sahaja',
    none:          'Tiada',
    notificationsSub: 'Lihat kemaskini tiket dan pemberitahuan penting',
    markAllRead:   'Tanda semua telah dibaca',
    notifStatusTitle: 'Status tiket dikemaskini',
    notifReplyTitle: 'Balasan staf baharu',
    notifResolvedTitle: 'Tiket selesai',
    ticketSummary: 'Ringkasan tiket',
    attach:        'Lampirkan',

    // General
    itSupport:     'Sokongan IT',
    facilities:    'Kemudahan',
    hr:            'HR',
    network:       'Rangkaian',
    hardware:      'Perkakasan',
    software:      'Perisian',
    optional:      'Pilihan' 
  },
}

const LangContext = createContext(null)

export function LangProvider({ children }) {
  const [lang, setLang] = useState('en')

  const t = (key) => translations[lang][key] ?? key

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  )
}

export function useLang() {
  return useContext(LangContext)
}
